import { useState, useEffect } from "react";
import MappedDocInfo from "./MappedDocInfo";
import { selectedTab } from "../../../redux/roleSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CaseServices } from "../../../services/CaseServices";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import EditStatusClaimModal from "./EditStatusClaimModal";
import TmsQueries from "../TmsQueries";
import CloseIcon from "../../../assets/crossIcon.svg";
const CaseStageUpdationAndDocInfo = ({
  cas,
  setConfirmationPopup,
  setUpdateStageMethodName,
  setSelectedCase,
  setPreinitiateOpen,
  AllCases,
}) => {
  const [initiating, setInitiating] = useState(false);
  const [opentStatusModal, setOpenStatusModal] = useState(false);
  const [openQueryModal, setQueryModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleInitiateEnhancement = async (caseItem) => {
    setInitiating(true);
    try {
      const response = await CaseServices.duringTreatmentDocChecker(
        caseItem.id,
      );
      if (response?.data?.duringTreatmentDocExists) {
        dispatch(selectedTab("ENHANCEMENT"));
        navigate("/Dashboard/EditCases", {
          state: { selectedCase: caseItem },
        });
      } else {
        window.alert(
          "Enhancement documents are not yet mapped. Please perform Initiate Enhancement process when documents are mapped.",
        );
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setInitiating(false);
  };
  return (
    <>
      <div className="flex items-center gap-2 ">
        {(cas?.submasterstagestatuses[0]?.commandCenterStage
          ?.toLowerCase()
          .includes("admission initiated on tms") ||
          cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("admission query reply initiated on tms")) && (
          <div
            style={{ border: "1px solid #017C57" }}
            className="text-xs bg-white text-[#017C57] font-semibold px-3 py-1 rounded-full cursor-pointer"
            onClick={() => {
              setConfirmationPopup(true);
              setUpdateStageMethodName({
                method: "handleAdmissionCancelledByHospital",
                case: cas,
              });
            }}
          >
            Admission Cancelled
          </div>
        )}
        {cas?.submasterstagestatuses[0]?.commandCenterStage
          ?.toLowerCase()
          .includes("approved by team c") ||
        cas?.submasterstagestatuses[0]?.commandCenterStage
          ?.toLowerCase()
          .includes("approved by team e") ||
        cas?.submasterstagestatuses[0]?.commandCenterStage
          ?.toLowerCase()
          .includes("approved by sr doctor") ? (
          <div
            style={{ border: "1px solid #017C57" }}
            className="text-xs bg-white text-[#017C57] font-semibold px-3 py-1 rounded-full cursor-pointer"
            onClick={() => {
              setConfirmationPopup(true);
              setUpdateStageMethodName({
                method: "handleInitiateOnTMS",
                case: cas,
              });
            }}
          >
            {cas?.submasterstagestatuses[0]?.commandCenterStage
              ?.toLowerCase()
              .includes("admission")
              ? "Initiate Admission on TMS"
              : cas?.submasterstagestatuses[0]?.commandCenterStage
                    ?.toLowerCase()
                    .includes("enhancement")
                ? "Initiate Enhancement on TMS"
                : cas?.submasterstagestatuses[0]?.commandCenterStage
                      ?.toLowerCase()
                      .includes("claim")
                  ? "Initiate Claim on TMS"
                  : ""}
          </div>
        ) : cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("request to admission") ? (
          <div
            style={{ border: "1px solid #017C57" }}
            className="text-xs bg-white text-[#017C57] font-semibold px-3 py-1 rounded-full cursor-pointer"
            onClick={() => {
              if (cas?.totalReferenceDocuments) {
                setConfirmationPopup(true);
                setUpdateStageMethodName({
                  method: "handleInitiateAdmission",
                  case: cas,
                });
              } else {
                window.alert(
                  "Please upload atleast one reference document before initiating the admission",
                );
                setSelectedCase(cas);
                setPreinitiateOpen(true);
              }
            }}
          >
            Initiate Admission
          </div>
        ) : cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("admission initiated on tms") ||
          cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("enhancement initiated on tms") ||
          cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("claim initiated on tms") ||
          cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("claim submitted done on tms") ||
          cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("query reply initiated on tms") ? (
          <div
            style={{ border: "1px solid #017C57" }}
            className="text-xs bg-white text-[#017C57] font-semibold px-3 py-1 rounded-full cursor-pointer"
            onClick={() => {
              setConfirmationPopup(true);
              setUpdateStageMethodName({
                method: "handleApprovedOnTMS",
                case: cas,
              });
            }}
          >
            {cas?.submasterstagestatuses[0]?.commandCenterStage
              ?.toLowerCase()
              .includes("admission")
              ? "Admission Approved on TMS"
              : cas?.submasterstagestatuses[0]?.commandCenterStage
                    ?.toLowerCase()
                    .includes("enhancement")
                ? "Enhancement Approved on TMS"
                : cas?.submasterstagestatuses[0]?.commandCenterStage
                      ?.toLowerCase()
                      .includes("claim")
                  ? "Claim Approved on TMS"
                  : ""}
          </div>
        ) : cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("claim approved on tms") ? (
          <div
            style={{ border: "1px solid #017C57" }}
            className="text-xs bg-white text-[#017C57] font-semibold px-3 py-1 rounded-full cursor-pointer"
            onClick={() => {
              setConfirmationPopup(true);
              setUpdateStageMethodName({
                method: "handleClaimSentToBank",
                case: cas,
              });
            }}
          >
            {" "}
            Payment Sent To Bank
          </div>
        ) : cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("claim sent to bank on tms") ? (
          <div
            style={{ border: "1px solid #017C57" }}
            className="text-xs bg-white text-[#017C57] font-semibold px-3 py-1 rounded-full cursor-pointer"
            onClick={() => {
              setOpenStatusModal(true);
            }}
          >
            {" "}
            Claim Amount Paid
          </div>
        ) : cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("claim amount paid by bank on tms") ? (
          <div
            style={{ border: "1px solid #017C57" }}
            className="text-xs bg-white text-[#017C57] font-semibold px-3 py-1 rounded-full cursor-pointer"
            onClick={() => {
              setConfirmationPopup(true);
              setUpdateStageMethodName({
                method: "handleRaiseErroneousConfirmation",
                case: cas,
              });
            }}
          >
            Raise Erroneous
          </div>
        ) : cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("claim rejected on tms") ? (
          <div
            style={{ border: "1px solid #017C57" }}
            className="text-xs bg-white text-[#017C57] font-semibold px-3 py-1 rounded-full cursor-pointer"
            onClick={() => {
              setConfirmationPopup(true);
              setUpdateStageMethodName({
                method: "handleRaiseReprocessConfirmation",
                case: cas,
              });
            }}
          >
            Raise Reprocess
          </div>
        ) : cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("erroneous claim request initiated") ? (
          <div
            style={{ border: "1px solid #017C57" }}
            className="text-xs bg-white text-[#017C57] font-semibold px-3 py-1 rounded-full cursor-pointer"
            onClick={() => {
              setConfirmationPopup(true);
              setUpdateStageMethodName({
                method: "handleInitiateErroneous",
                case: cas,
              });
            }}
          >
            Request Erroneous
          </div>
        ) : cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("reprocess claim request initiated") ? (
          <div
            style={{ border: "1px solid #017C57" }}
            className="text-xs bg-white text-[#017C57] font-semibold px-3 py-1 rounded-full cursor-pointer"
            onClick={() => {
              setConfirmationPopup(true);
              setUpdateStageMethodName({
                method: "handleInitiateReprocess",
                case: cas,
              });
            }}
          >
            Request Reprocess
          </div>
        ) : cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("query on tms") ||
          cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("query forwarded to doctor") ? (
          <div
            style={{ border: "1px solid #017C57" }}
            className="text-xs bg-white text-[#017C57] font-semibold px-3 py-1 rounded-full cursor-pointer"
            onClick={() => {
              setQueryModal(true);
            }}
          >
            {" "}
            Proceed
          </div>
        ) : cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("admission approved on tms") ||
          cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("request to add new enhancement procedure") ||
          cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("enhancement approved on tms") ||
          cas?.submasterstagestatuses[0]?.commandCenterStage
            ?.toLowerCase()
            .includes("enhancement rejected") ? (
          <div className="flex gap-2">
            {" "}
            <button
              style={{ border: "1px solid #017C57" }}
              className="text-xs font-semibold px-3 py-1 text-[#017C57] bg-white rounded-full border-0 cursor-pointer capitalize"
              onClick={() => {
                handleInitiateEnhancement(cas);
              }}
            >
              {cas?.submasterstagestatuses[0]?.commandCenterStage
                ?.toLowerCase()
                .includes("enhancement approved on tms") ||
              cas?.submasterstagestatuses[0]?.commandCenterStage
                ?.toLowerCase()
                .includes("enhancement rejected")
                ? "Re-Initiate Enhancement"
                : "Initiate Enhancement"}
            </button>
            <button
              style={{ border: "1px solid #017C57" }}
              className="text-xs font-semibold px-3 py-1 text-[#017C57] bg-white rounded-full border-0 cursor-pointer capitalize"
              onClick={() => {
                dispatch(selectedTab("DISCHARGE"));
                navigate("/Dashboard/EditCases", {
                  state: { selectedCase: cas },
                });
              }}
            >
              Initiate Discharge
            </button>
          </div>
        ) : (
          // <MappedDocInfo cas={cas} />
          ""
        )}
      </div>
      {opentStatusModal && (
        <div className="fixed top-0 left-0 h-screen w-screen flex items-center justify-center bg-[#017C5780] z-[1203]">
          <EditStatusClaimModal
            setEditStatus={setOpenStatusModal}
            caseId={cas.id}
            caseDetails={cas}
            AllCases={AllCases}
          />
        </div>
      )}
      {openQueryModal && (
        <div className="fixed top-0 left-0 h-screen w-screen flex items-center justify-center bg-[#017C5780] z-[1203]">
          <div className="relative w-[95%] h-[95%] rounded-[32px] bg-white p-6 overflow-hidden">
            <TmsQueries
              caseId={cas.id}
              setEditStatus={setQueryModal}
              AllCases={AllCases}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CaseStageUpdationAndDocInfo;
